import { useEffect, useContext } from "react";
import api from "../../Utils/api";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../../Utils/GlobalContext";

function RedirectToDefault() {
  const navigate = useNavigate();
  const { globalData, setGlobalData } = useContext(GlobalContext);
  const userId = globalData?.user_id || localStorage.getItem("user_id");

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    const doRedirect = async () => {
      let targetPath = "/Estatisticas";
      let classificacao = null;

      if (userId && token) {
        try {
          const rotaRes = await api.get(`/api/usuarios/ObterRotaPadrao/${userId}`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          if (rotaRes?.data?.rota_padrao) {
            targetPath = rotaRes.data.rota_padrao.startsWith("/")
              ? rotaRes.data.rota_padrao
              : `/${rotaRes.data.rota_padrao}`;
            setGlobalData((prev) => ({ ...prev, rota_padrao: targetPath }));
          }
        } catch (err) {
          console.error("Erro ao obter dados iniciais:", err);
        }
      }

      if (targetPath === "/Empresas" && classificacao) {
        setGlobalData((prev) => ({ ...prev, classificacao }));
      }
      navigate(targetPath, { replace: true });
    };

    doRedirect();
  }, [navigate, setGlobalData, userId]);

  return null;
}

export default RedirectToDefault;
